var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backend-manage layout-row"},[_c('left-nav'),_c('router-view',{staticClass:"routerView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }